<template>
  <div class="tab">
    <el-footer v-if="showManageFooter" class="tab__footer page__active_bar">
      <el-button
        v-if="$can('update', 'sip_servers')"
        class="page__active_button"
        id="submit"
        type="primary"
        @click="submit"
      >
        Сохранить
      </el-button>
      <el-button
        v-if="$can('delete', 'sip_servers')"
        class="page__active_button"
        id="delete"
        type="danger"
        @click="removeSipServer"
      >
        Удалить
      </el-button>
    </el-footer>
    <main class="page_container">
      <el-form class="page__form" :model="form" ref="form" :rules="rules" label-position="right" label-width="200px">
          <el-form-item label="IP-адрес" prop="ip">
            <el-input placeholder="0.0.0.0" id="ip" size="small" v-model="form.ip" />
          </el-form-item>
          <el-form-item label="Порт сервиса" prop="port_service">
            <el-input placeholder="Порт сервиса управления конфигурациями" id="port_service" size="small" v-model="form.port_service" />
          </el-form-item>
          <el-form-item label="Порт для домофонов" prop="port_intercom">
            <el-input placeholder="Порт для домофонов" id="port_intercom" size="small" v-model="form.port_intercom" />
          </el-form-item>
          <el-form-item label="Порт для устройств" prop="port_client_device">
            <el-input placeholder="Порт для устройств" id="port_client_device" size="small" v-model="form.port_client_device" />
          </el-form-item>
          <el-form-item label="Логин" prop="login">
            <el-input placeholder="Логин сервиса управления конфигурациями" id="login" size="small" v-model="form.login" />
          </el-form-item>
          <el-form-item label="Пароль" prop="password">
            <el-input type="password" placeholder="(Оставить пустым, если не требуется изменять)" id="password" size="small" v-model="form.password" :readonly="!$can('update', 'forms')"/>
          </el-form-item>
      </el-form>
    </main>
  </div>
</template>

<script>
import { required, length, validatorNumber, validatorIp } from "@/core/helpers/validators";
import { mapActions, mapState } from "vuex";

export default {
  name: "SipServerEditTab",
  data() {
    return {
      form: {
        ip: null,
        port_service: null,
        port_intercom: null,
        port_client_device: null,
        login: null,
      },
      rules: this.$can("update", "sip_servers")
        ? {
            ip: [required(), validatorIp],
            port_service: [validatorNumber],
            port_intercom: [validatorNumber],
            port_client_device: [validatorNumber],
            login: [required()],
            password: []
          }
        : null,
    };
  },
  computed: {
    ...mapState("sip_server", ["sip_server"]),
    showManageFooter() {
      return this.$can("update", "sip_servers") || this.$can("delete", "sip_servers");
    },
  },
  watch: {
    sip_server(sip_server) {
      this.form = Object.assign({}, sip_server);
    },
  },
  methods: {
    ...mapActions("sip_server", {
      save: "UPDATE_SIP_SERVER",
      deleteSipServer: "DELETE_SIP_SERVER",
    }),
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.save({
            id: this.sip_server.id_sip_server,
            data: {
              ip: this.form.ip,
              port_service: this.form.port_service,
              port_intercom: this.form.port_intercom,
              port_client_device: this.form.port_client_device,
              login: this.form.login,
            },
          })
            .then(() => {
              this.$message({
                message: "Информация обновлена",
                type: "success",
              });
            })
            .catch(() => {
              this.$message({
                message: `При редактировании SIP-сервера произошла ошибка`,
                type: "error",
              });
            });
        }
        return valid;
      });
    },
    removeSipServer() {
      this.$confirm("Вы точно хотите удалить SIP-сервер?", "Удаление", {
        confirmButtonText: "Удалить",
        cancelButtonText: "Отмена",
        type: "warning",
      }).then(() => {
        this.deleteSipServer(this.sip_server.id_sip_server).then(() => {
          this.$message({
            message: "SIP-сервер удален",
            type: "success",
          });
          window.history.back();
        });
      });
    },
  },
};
</script>
